var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaximizeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40008 0H2.39998C1.07458 0 0 1.07457 0 2.39996V9.59994C0 10.9253 1.07458 12 2.39998 12H9.60002C10.9254 12 12 10.9253 12 9.59994V6.60012C12 6.26884 11.7312 6.00005 11.4 6.00005C11.0689 6.00005 10.8001 6.26884 10.8001 6.60012V9.59994C10.8001 10.2624 10.2625 10.8 9.60002 10.8H2.39998C1.73693 10.8 1.19994 10.2624 1.19994 9.59994V2.39996C1.19994 1.73702 1.73693 1.20003 2.39998 1.20003H5.40008C5.73126 1.20003 6.00005 0.931137 6.00005 0.599964C6.00005 0.268791 5.73126 0 5.40008 0ZM9.95154 1.20003H7.79996C7.46878 1.20003 7.19999 0.931137 7.19999 0.599964C7.19999 0.268791 7.46878 0 7.79996 0H11.4C11.7312 0 12 0.268791 12 0.599964V4.19995C12 4.53113 11.7312 4.80002 11.4 4.80002C11.0688 4.80002 10.8 4.53113 10.8 4.19995V2.04839L6.42419 6.42418C6.19024 6.65822 5.80974 6.65822 5.57582 6.42418C5.34117 6.19024 5.34117 5.80984 5.57582 5.57582L9.95154 1.20003Z",
    fill: "#4F6E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximizeIcon);
export default __webpack_public_path__ + "static/media/maximize-icon.5fa263f64d97d374e333cac562a165d0.svg";
export { ForwardRef as ReactComponent };